export default __webpack_public_path__ + "static/media/clock.c03ee4e9.svg";